<template>
  <v-snackbar v-model="shareStore.snackBar.show" :timeout="timeout" color="primary" location="top">
    <p class="text-body-2">{{ shareStore.snackBar.message }}</p>
    <template v-slot:actions>
      <v-btn color="white" variant="tonal" @click="shareStore.closeSnackBar">
        متوجه شدم
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import {useShareStore} from '~/store/share.js';

// initialize share store
const shareStore = useShareStore();

/** timeout show snackbar **/
const timeout = ref(5000);

</script>

<style scoped></style>